import { useHasPermissions } from './hasPermission';
import type { Permission } from './permissions-request';

export const useCanExitKiosk = () => {
  const requiredPermissions: Permission[] = ['accounts.kiosk_activation'];
  return useHasPermissions(requiredPermissions);
};

/**
 * Duty-toggle gating — SMS analog of AIM's `permissionDutyStatus()`
 * and `permissionCanChangeDutyStatus()`
 * (`apps/aegix-aim-react/src/utils/permissionList.tsx`). AIM gates the duty
 * toggle on BOTH of these; SMS mirrors that gate exactly so the toggle
 * self-hides when the user/role lacks either permission.
 *
 * AIM uses synchronous helpers backed by the persisted user; SMS uses the
 * reactive `useHasPermissions` hook (re-renders on `permissions_version`
 * bumps), consistent with the rest of SMS's permission machinery.
 */
export const permissionDutyStatus = () => {
  // Matches iOS, which gates duty on `accounts.view_userduty`
  // (paired with `accounts.change_userduty` below).
  const requiredPermissions: Permission[] = ['accounts.view_userduty'];
  return useHasPermissions(requiredPermissions);
};

export const permissionCanChangeDutyStatus = () => {
  const requiredPermissions: Permission[] = ['accounts.change_userduty'];
  return useHasPermissions(requiredPermissions);
};
